<template>
  <v-app>
    <spinner />

    <v-app-bar app flat fixed color="white" v-if="$route.name !== 'error'">
      <v-btn v-if="$route.name === 'main'" fab text x-small color="black" @click="userLogout">
        <v-icon size="24">mdi-logout</v-icon>
      </v-btn>
<!--      <v-btn fab text x-small color="black" @click="consoleRoute">-->
<!--        <v-icon size="24">mdi-routes</v-icon>-->
<!--      </v-btn>-->
      <v-btn v-if="$route.name !== 'main'" fab text x-small color="black" @click="goBack">
        <v-icon size="24">mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title style="height:24px;" v-if="this.env === 'production'">
        <logo v-if="$route.name === 'main' && GET_USER_DATA.ssnEnterCd === '01'" :width="68" :height="24" />
        <logo-bgf v-else-if="$route.name === 'main' && GET_USER_DATA.ssnEnterCd === '10'" :width="125" :height="24" />
        <h3 v-else>{{toolbarTitle}}</h3>
      </v-toolbar-title>
      <v-toolbar-title style="height:24px;" v-else>
        <logo-dev v-if="$route.name === 'main' && GET_USER_DATA.ssnEnterCd === '01'" :width="108" :height="24" />
        <logo-bgf-dev v-else-if="$route.name === 'main' && GET_USER_DATA.ssnEnterCd === '10'" :width="165" :height="24" />
        <h3 v-else>{{toolbarTitle}}</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
<!--      <v-btn fab text x-small v-if="cancelBtnShow" @click="cancelEvent"><h3>취소</h3></v-btn>-->
<!--      <v-btn fab text x-small>{{$route.name}}</v-btn>-->
    </v-app-bar>

    <v-main style="padding : 56px 0;">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
<!--      <v-slide-x-transition mode="out-in">-->
<!--        <router-view />-->
<!--      </v-slide-x-transition>-->
    </v-main>

<!--    <bottom-nav v-show="bottomNav" ref="rBottomNav" />-->
    <v-expand-transition>
      <v-footer fixed padless :app="bottomNav && $route.name !== 'error' && $route.name !== 'loginCer'" v-show="bottomNav && $route.name !== 'error' && $route.name !== 'loginCer'" elevation="4" color="white" class="main-footer">
        <v-row justify="center" no-gutters>
          <v-col cols="0"></v-col>
          <v-col cols="3" align="center" :class="activeMenu === 'main' ? 'active' : ''">
            <v-btn fab text color="green" :ripple="false" @click="movePage('main')" class="top-icon">
              <v-icon v-if="activeMenu === 'main'">mdi-home</v-icon>
              <v-icon v-else>mdi-home-outline</v-icon>
              메인
            </v-btn>
          </v-col>
          <v-col cols="3" align="center" :class="activeMenu === 'calendar' ? 'active' : ''">
            <v-btn fab text color="green" :ripple="false" @click="movePage('calendar')" class="top-icon">
              <v-icon  v-if="activeMenu === 'calendar'">mdi-calendar-range</v-icon>
              <v-icon v-else>mdi-calendar-range-outline</v-icon>
              일정
            </v-btn>
          </v-col>
          <v-col cols="3" align="center" :class="activeMenu === 'memberSearch' ? 'active' : ''">
            <v-btn fab text color="green" :ripple="false" @click="movePage('memberSearch')" class="top-icon">
              <v-icon  v-if="activeMenu === 'memberSearch'">mdi-search-web</v-icon>
              <v-icon v-else>mdi-magnify</v-icon>
              직원찾기
            </v-btn>
          </v-col>
          <v-col cols="3" align="center" :class="activeMenu === 'allMenu' ? 'active' : ''">
            <v-btn fab text color="green" :ripple="false" @click="movePage('allMenu')" class="top-icon">
              <v-icon  v-if="activeMenu === 'allMenu'">mdi-menu-open</v-icon>
              <v-icon v-else>mdi-menu</v-icon>
              전체
            </v-btn>
          </v-col>
          <v-col cols="0"></v-col>
        </v-row>
      </v-footer>
    </v-expand-transition>

    <!-- [모달] 신청서 뷰어 -->
    <application-viewer-dialog />

    <!-- 2차인증 모달 -->
    <v-dialog v-model="showSecondAuthenticateDialog" v-if="showSecondAuthenticateDialog" fullscreen hide-overlay>
      <LoginCertification @close="$store.commit('SET_SHOW_SECOND_AUTHENTICATE', false)"></LoginCertification>
    </v-dialog>
  </v-app>
</template>
<style>
.top-icon .v-btn__content{
  display : flex;
  flex-direction: column;
}
.main-footer div{
  margin-top : 2px;
  border : none;
}
.main-footer div.active{
  margin-top : 0;
  border-top : 2px solid #4CAF50;
}
</style>
<script>
import Spinner from '@/components/common/Spinner.vue'; // 스피너 컴포넌트
import ApplicationViewerDialog from '@/components/application/dialog/ApplicationViewerDialog.vue';
import { mapGetters } from 'vuex';
import {logout, postNewSession} from '@/api/auth';
import Logo from "@/assets/customIcon/Logo.vue";
import LogoBgf from "@/assets/customIcon/LogoBGF.vue";
import LogoDev from "@/assets/customIcon/LogoDev.vue";
import LogoBgfDev from "@/assets/customIcon/LogoBGFDev.vue";
import LoginCertification from "@/views/home/LoginCertification.vue";

export default {
  name: 'App',
  data: () => ({
    activeValue : 'main',
    showSecondAuthenticate : false,
    env : process.env.NODE_ENV,
  }),
  computed: {
    ...mapGetters(['GET_BOTTOM_NAV_FLAG', 'GET_USER_DATA'])
    , bottomNav() {
      // const bottomNavFlag = this.$route.meta.bottomNav;
      // return (!(bottomNavFlag === false || this.GET_BOTTOM_NAV_FLAG === false));
      return this.$route.meta.bottomNav;
    }
    , toolbarTitle(){
      if(!this.$route.name) return '';
      const routeName = this.$route.name.toUpperCase();
      switch (routeName){
        case 'CALENDAR':
          return '일정';
        case 'MEMBERSEARCH' :
          return '직원 찾기';
        case 'ALLMENU' :
          return '전체 메뉴';
        case 'APPRDOC' :
          return '문서';
        case 'GNTGUBUNMENU' :
        case 'WORKSCHEDULETIME' :
        case 'HOLREPLACEAPP' :
        case 'LEAABSAPPSTEP1' :
        case 'LEAABSAPPSTEP2' :
        case 'LEAABSBOXVIEW' :
        case 'EDUSAPP' :
        case 'VACCINATION' :
        case 'RECERTAPPSTEP' :
        case 'RECERTTENURETAXAPPVIEW':
        case 'RECERTTENUREENGAPPVIEW' :
        case 'RECERTTENUREAPPVIEW' :
        case 'RECERTGABTAXVIEW' :
        case 'STARTDATEAPPL' :
        case 'ENDDATEAPPL' :
        case 'DATEAPPL' :
        case 'RECERTLEAVEAPPVIEW' :
        case 'WORKSCHEDULETIME1' :
          return '신청서';
        case 'WORKSCHEDULETIMEVIEW' :
          return '시차근무신청';
        case 'DATEHOLREPLACEAPPVIEW' :
          return '휴일사전대체근무신청';
        case 'EDUSAPPSUB' :
          return '학자금신청';
        case 'VACCINATIONSUB' :
          return '독감예방접종신청';
        case 'CANCELMENU' :
        case 'HOLREPLACEBOXVIEW' :
          return '취소신청';
        case 'SURVEYBOXVIEW' :
        case 'SURVEYANSWER' :
          return '교육만족도 조사';
        case 'LABORCONTRACT' :
        case 'ANNUALCONTRACT' :
        case 'CONSENTCONTRACT' :
          return '계약서';
      }
      return '';
    }
    , cancelBtnShow() {
      return this.$route.meta.cancelBtn;
    }
    , activeMenu(){
      const routeName = this.$route.name;
      if(!routeName) return 'allMenu';
      if(routeName.indexOf('main') > -1) return 'main';
      else if(routeName.indexOf('calendar') > -1) return 'calendar';
      else if(routeName.indexOf('memberSearch') > -1) return 'memberSearch';
      return 'allMenu';
    }
    , showSecondAuthenticateDialog(){
      return this.$store.getters.GET_SHOW_SECOND_AUTHENTICATE;
    }
  },
  methods: {
    /* 세션정보 갱신 및 반환 */
    async saveNewSession() {
      try {
        const newSessionRes = await postNewSession();
        const newSessionData = newSessionRes.data.data;
        this.toMain();
      } catch (error) {
        alert(error);
      }
    },

    /* 메인으로 이동 */
    toMain() {
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');
      this.$router.replace('/main');
    },

    async userLogout() {
      if (confirm('종료 하시겠습니까?')) {
        try {
          const response = await logout();
        
          if (response.data.message === 'OK') {
            this.$store.commit('cleanToken');
          } else {
            alert('잠시 후 다시 시도해주세요.');
          }
        } catch (error) {
          console.log(error);
        }
        // IBGF로 이동
        const url = 'exit_webview';
        location.href = url;
      }
    }

    , goBack(){
      this.$router.back();
    }

    , movePage(page){
      this.activeValue = page;
      this.$router.push('/' + page);
    }

    , cancelEvent(){
      if(confirm('작성중인 신청서를 취소하시겠습니까? 작성한 내용은 사라집니다.')){
        this.$router.replace('/allMenu');
      }
    }

    , consoleRoute(){
      console.log('history : ', this.$router.history);
      console.log('$router : ', this.$router);
      console.log('window history : ', window.history.length);
    }
  },
  components: {Logo, LogoBgf, LogoDev, LogoBgfDev, Spinner, ApplicationViewerDialog, LoginCertification},
  created() {
    /*
     * 쿠키없을때 validateSession 호출 callback
     * 앱에서 가져온 데이터로 쿠키 셋팅
     */
    /*
    window.afterValidateSession = event => {
      try {
        const returnData = JSON.parse(event).afterValidateSession;
        const userData = returnData.contextData;
        console.log('App.vue userData : ' + JSON.stringify(userData));
        if (
          process.env.NODE_ENV === 'local' ||
          process.env.NODE_ENV === 'development'
        ) {
          this.$store.commit('setUserData', userData);
          this.$store.commit('setToken', userData);
        }

        // 쿠키 없는 상태, api 호출시 헤더에 담을 토큰 셋팅
        this.$store.commit('setTokenObj', userData);

        // 세션정보 갱신 및 반환
        this.saveNewSession();
      } catch (error) {
        alert('#mobile - !error afterValidateSession ' + error);
      }
    };
    */
  },
};
</script>

<style>
.col-3 {
  flex: 0 0 22%;
  max-width: 22%;
}

</style>
